import { render } from "./live.vue?vue&type=template&id=eb607916&scoped=true&ts=true"
import script from "./live.vue?vue&type=script&lang=ts"
export * from "./live.vue?vue&type=script&lang=ts"

import "./live.vue?vue&type=style&index=0&id=eb607916&scoped=true&lang=css"

import exportComponent from "/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eb607916"]])

export default __exports__